import moment from "moment";
import { DATE_FORMATS, MARKETPLACES } from "../constants";

const getDate = value => value ? moment(value).format(DATE_FORMATS.DATE) : '';

const getFullTime = value => value ? moment(value).format(DATE_FORMATS.DATE_TIME) : '';

const getFullTimeSeconds = value => value ? moment(value).format(DATE_FORMATS.DATE_TIME_SECONDS) : '';

const getLocalFullTime = value => value ? moment(value).utc(value).local().format(DATE_FORMATS.DATE_TIME) : '';

const getIntegrationSyncTime = (value, inProgress, i18n) => {
    if (value) {
        return moment(value).format(DATE_FORMATS.DATE_TIME);
    }
    if (!inProgress) {
        return i18n.t('integrations.syncIsQueuedNow');
    }
    return '';
};

const getMarketplace = value => MARKETPLACES[value];

const getDateDifference = (startDate, endDate, i18n) => {
    const years = endDate.diff(startDate, 'years');
    const month = endDate.diff(startDate, 'month') % 12;
    startDate.add(years, 'years').add(month, "month");
    const days = endDate.diff(startDate, 'days');
    let yearLabel = '';
    if (years) {
        yearLabel = `${years} ${i18n.t(years === 1 ? 'year' : 'years')} `;
    }
    let monthLabel = '';
    if (month) {
        monthLabel = `${month} ${i18n.t(month === 1 ? 'month' : 'months')} `;
    }
    let dayLabel = '';
    if (days) {
        dayLabel = `${days} ${i18n.t(days === 1 ? 'day' : 'days')}`;
    }
    return `${yearLabel}${monthLabel}${dayLabel}`
};


export default {
    getDate,
    getFullTime,
    getLocalFullTime,
    getMarketplace,
    getIntegrationSyncTime,
    getFullTimeSeconds,
    getDateDifference
};